module.exports = __webpack_public_path__ + "static/media/malphos_1000ce.1f0cb00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/trips/curativa/malphos_1000ce.png
// module id = 1089
// module chunks = 3